import React from 'react';
import Modal from 'components/Modal';

import Rating from 'components/Rating';
import photoPlaceholder from 'assets/img/icons/profile.svg';

import {
  RatingContainer, UserRating, UserAvatar, UserName, RatingInfos, RatingDate, RatingText,
} from './styles';

const RatingsProModal = ({ isOpen, toggle, proRatings }) => (
  <Modal
    isOpen={isOpen}
    toggle={toggle}
    title="AVALIAÇÕES"
    width="800px"
  >
    {proRatings && proRatings.length > 0 && proRatings.map(rating => (
      <RatingContainer key={rating.id}>
        <RatingDate>{new Date(rating.created).toLocaleDateString('pt-BR')}</RatingDate>
        <UserRating>
          <UserAvatar src={rating.profile_picture.indexOf('http') === 0 && !rating.is_anonymous ? rating.profile_picture : photoPlaceholder} />
          <RatingInfos>
            <UserName>{!rating.is_anonymous ? rating.name : 'Anônimo'}</UserName>
            <Rating initialRating={rating.rating} readonly />
          </RatingInfos>
        </UserRating>
        {rating.comment
          && <RatingText>{rating.comment}</RatingText>
        }
      </RatingContainer>
    ))}
  </Modal>
);

export default RatingsProModal;
